import { Box, Button } from "@mui/material";
import { FormField } from "../";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { IP_METHOD, IP_METHOD_OPTIONS } from "../constants/network";
import { LoadingButton } from "@mui/lab";

const styles = () => {
  return {
    "& .select-network": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .mui-field": {
      minHeight: "78px",
      "& .MuiFormGroup-root": {
        justifyContent: "center",
        "& .MuiFormControlLabel-root": {
          width: "120px",
        },
      },
    },
    "& .button-footer": {
      mt: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    "& .ip-method-field": {
      "& .mui-field": {
        display: "flex",
        alignItems: "center",
        minHeight: "48px",
      },
    },
  };
};

const EnterWifiNetwork = ({
  selectedWifi,
  onCancel,
  onClickSave,
  ipMethodSelect = false,
}) => {
  const [formData, setFormData] = useState({
    ssid: "",
    password: "",
    method: IP_METHOD.dhcp,
    ip: "",
    netmask: "",
    gateway: "",
    primaryDNS: "",
    secondaryDNS: "",
  });

  const [errors, setErrors] = useState({
    ssid: "",
    password: "",
  });

  const [enterDetails, setEnterDetails] = useState(false);

  useEffect(() => {
    if (selectedWifi.ssid === "enterDetails") {
      setEnterDetails(true);
    } else {
      setEnterDetails(false);
      setFormData({
        ...formData,
        ssid: selectedWifi.ssid,
        password: selectedWifi?.password,
      });
    }
  }, [selectedWifi]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setErrors({
      ...errors,
      [e.target.name]: isEmpty(e.target.value) ? "Required" : "",
    });
  };

  const anyError = () => !Object.values(errors).every((it) => isEmpty(it));

  const onConnect = () => {
    let data = {
      wifi: {
        method: formData.method,
        ssid: formData?.ssid,
        password: formData?.password,
      },
    };

    if (formData.method === IP_METHOD.static) {
      data = {
        wifi: {
          method: formData.method,
          ssid: formData?.ssid,
          password: formData?.password,
          ip: formData.ip,
          netmask: formData.netmask,
          gateway: formData.gateway,
          dns: [formData.primaryDNS, formData.secondaryDNS],
        },
      };
    }

    onClickSave(data);
  };

  return (
    <Box sx={styles}>
      {enterDetails && (
        <FormField
          label="SSID"
          name="ssid"
          value={formData.ssid}
          variant="filled"
          onChange={onChange}
          autoComplete="off"
          error={errors.ssid}
          onBlur={onBlur}
        />
      )}

      <FormField
        label="Password"
        name="password"
        value={formData.password}
        variant="filled"
        onChange={onChange}
        autoComplete="off"
        type="password"
        error={errors.password}
        onBlur={onBlur}
      />

      <Box className="ip-method-field">
        <FormField
          showLabel={true}
          formFieldLabel="IP Method"
          name="method"
          type={ipMethodSelect ? "select" : "radioboxgroup"}
          value={formData.method}
          variant="filled"
          onChange={onChange}
          options={IP_METHOD_OPTIONS}
        />
      </Box>

      {formData.method === IP_METHOD.static && (
        <Box className="ip-method-field">
          <FormField
            showLabel={true}
            formFieldLabel="IP Address"
            name="ip"
            value={formData.ip}
            variant="filled"
            onChange={onChange}
            autoComplete="off"
            type="ipInput"
          />

          <FormField
            showLabel={true}
            formFieldLabel="Netmask"
            name="netmask"
            value={formData.netmask}
            variant="filled"
            onChange={onChange}
            autoComplete="off"
            type="ipInput"
          />

          <FormField
            showLabel={true}
            formFieldLabel="Gateway"
            name="gateway"
            value={formData.gateway}
            variant="filled"
            onChange={onChange}
            autoComplete="off"
            type="ipInput"
          />

          <FormField
            showLabel={true}
            formFieldLabel="Primary DNS"
            name="primaryDNS"
            value={formData.primaryDNS}
            variant="filled"
            onChange={onChange}
            autoComplete="off"
            type="ipInput"
          />

          <FormField
            showLabel={true}
            formFieldLabel="Secondary DNS"
            name="secondaryDNS"
            value={formData.secondaryDNS}
            variant="filled"
            onChange={onChange}
            autoComplete="off"
            type="ipInput"
          />
        </Box>
      )}

      <Box className="button-footer">
        <Button onClick={onCancel}>Cancel</Button>
        <LoadingButton
          onClick={onConnect}
          disabled={isEmpty(formData?.password) || anyError()}
        >
          Connect
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default EnterWifiNetwork;
